<template>
  <BaseTableItemAction
    v-can:[showPermission]
    v-on="$listeners"
    v-bind="$attrs"
    icon="mdi-eye"
    actionName="عرض التفاصيل"
    :to="'/training-program-application-questions/' + item.id"
  >
    <slot></slot>
  </BaseTableItemAction>
</template>

<script>
import { READ_TP_APPLICATION_QUESTIONS_PERMISSION } from "@/core/statics/Permissions";

export default {
  props: {
    item: Object,
  },
  data() {
    return {
        showPermission: READ_TP_APPLICATION_QUESTIONS_PERMISSION,
    };
  },
};
</script>
